import Card from '@material-tailwind/react/Card';
import Icon from '@material-tailwind/react/Icon';

import {Link} from 'react-router-dom';

export default function AddInvestmentCard() {
    return (
        <div className="px-4 mb-10">
            <Link to="/funds">
                <div className="rounded-xl overflow-hdden shadow-md p-4 cursor-pointer w-full h-full flex justify-center items-center bg-gray-100 border-0 hover:shadow-2xl transition hover:bg-orange hover:text-white">
                    <div className="flex items-center h-full">
                        <Icon name="add" size="2xl"/>
                        <h2 className="ml-1 m-0 font-semibold text-lg">{" "}New Investment</h2>
                    </div>
                </div>
            </Link>
        </div>
    );
}
